import { useState } from 'react';
import Modal from "../../modal/Modal";
import {useModal} from "../../modal/useModal";
import {showErrorNotification} from "../../../util/notifications";
import useApi from "../../../api";
import classNames from 'classnames';
import { useQueryClient } from 'react-query'

const RemoveApiKeyModal = ({modalId, apikey}) => {
    const {closeModal} = useModal();
    const {deleteApiKey} = useApi();
    const [isLoading, setIsLoading] = useState(false);
    const queryClient = useQueryClient();

    const buttonClass = classNames('button', {
        'button--loading': isLoading,
    });

    const onDeleteClick = async () => {
        setIsLoading(true);
        try {
            await deleteApiKey(apikey.id);
            await queryClient.invalidateQueries('apikeys');
        } catch (e) {
            console.error(e);
            showErrorNotification('Something went wrong deleting the API key.');
        }
        closeModal(modalId);
    }

    return (
        <Modal modalId={modalId}>
            <h1 className="modal__title">Remove API Key</h1>
            Are you sure you want to delete this API key?
            <div className="modal__footer">
                <button className="button button--link" onClick={() => closeModal(modalId)}>Cancel</button>
                <button className={buttonClass} onClick={onDeleteClick}>Delete</button>
            </div>
        </Modal>
    )
};

export default RemoveApiKeyModal;
